/* Hygge Store Locator — custom element <hg-store-locator> (Leaflet + OpenStreetMap/CARTO). Update-safe, non-Dawn. */
(function () {
  var RANGE = {
    secco: { label: 'Secco', cls: 'secco', icon: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 9h14l-1.2 9.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 9Z"/><path d="M4 7.5C4 6 7.6 5 12 5s8 1 8 2.5S16.4 10 12 10 4 9 4 7.5Z" opacity=".55"/></svg>' },
    umido: { label: 'Umido', cls: 'umido', icon: '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="12" height="16" rx="2.4"/><rect x="8.4" y="8" width="7.2" height="3" rx="1.2" fill="#fff" opacity=".7"/></svg>' },
    snack: { label: 'Snack', cls: 'snack', icon: '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="6.6" cy="6.6" r="2.3"/><circle cx="17.4" cy="17.4" r="2.3"/><circle cx="9" cy="5" r="1.7"/><circle cx="5" cy="9" r="1.7"/><circle cx="19" cy="15" r="1.7"/><circle cx="15" cy="19" r="1.7"/></svg>' },
    gatto: { label: 'Gatto', cls: 'gatto', icon: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 10 4 4l4.2 3.2A7.6 7.6 0 0 1 12 6.4c1.4 0 2.7.3 3.8.8L20 4l-1 6v5.5A3.5 3.5 0 0 1 16.5 19h-9A3.5 3.5 0 0 1 4 15.5V10Z" opacity=".18"/><path d="M5 10 4 4l4.2 3.2A7.6 7.6 0 0 1 12 6.4c1.4 0 2.7.3 3.8.8L20 4l-1 6" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="9.4" cy="12.6" r="1.05"/><circle cx="14.6" cy="12.6" r="1.05"/><path d="M12 14.8c-.85 0-1.4.45-1.4 1 0 .5.55.8 1.4.8s1.4-.3 1.4-.8c0-.55-.55-1-1.4-1Z"/></svg>' }
  };
  var FOOD = ['secco', 'umido', 'snack'];
  var FULL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var TEAL = '#67ABB0', TEAL_DEEP = '#34707A';
  function pinSVG(f) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">' +
      '<path d="M16 1.5C8.3 1.5 2 7.6 2 15.2 2 24.9 13 39.2 16 40.5 19 39.2 30 24.9 30 15.2 30 7.6 23.7 1.5 16 1.5Z" fill="' + f + '" stroke="#fff" stroke-width="2"/>' +
      '<circle cx="16" cy="15" r="7.8" fill="#fff"/>' +
      '<g fill="' + f + '"><circle cx="12.8" cy="14.3" r="1.45"/><circle cx="16" cy="12.6" r="1.55"/><circle cx="19.2" cy="14.3" r="1.45"/><path d="M16 15.2c-2.1 0-3.45 1.45-3.45 2.9 0 1.2 1.2 1.75 3.45 1.75s3.45-.55 3.45-1.75c0-1.45-1.35-2.9-3.45-2.9Z"/></g></svg>';
  }
  function haversine(a, b, c, d) { var R = 6371, t = function (x) { return x * Math.PI / 180; }; var u = t(c - a), v = t(d - b); var q = Math.sin(u / 2) * Math.sin(u / 2) + Math.cos(t(a)) * Math.cos(t(c)) * Math.sin(v / 2) * Math.sin(v / 2); return R * 2 * Math.atan2(Math.sqrt(q), Math.sqrt(1 - q)); }
  function fmtDist(km) { return km < 1 ? Math.round(km * 1000) + ' m' : km.toFixed(km < 10 ? 1 : 0).replace('.', ',') + ' km'; }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function dirURL(s) { return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng; }

  class HgStoreLocator extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      this.zoom = parseInt(this.getAttribute('data-zoom') || '6', 10);
      this.showRanges = this.getAttribute('data-show-ranges') === 'true';
      this.center = [42.5, 12.5];
      var node = document.getElementById('hgloc-stores');
      try { this.stores = JSON.parse(node ? node.textContent : '[]'); } catch (e) { this.stores = []; }
      this.$ = function (s) { return this.querySelector(s); }.bind(this);
      this.listEl = this.$('.hgloc-list');
      this.countEl = this.$('[data-count]');
      this.emptyEl = this.$('.hgloc-empty');
      this.origin = null; this.activeFilter = 'all'; this.activeId = null; this.markers = {};
      this.bindUI();
      this.renderList();
      if (window.L) this.initMap(); else console.error('[hgloc] Leaflet non caricato');
    }

    bindUI() {
      var self = this;
      var go = this.$('[data-go]'), q = this.$('[data-q]'), geo = this.$('[data-geo]');
      if (go) go.addEventListener('click', function () { self.search(); });
      if (q) q.addEventListener('keydown', function (e) { if (e.key === 'Enter') self.search(); });
      if (geo) geo.addEventListener('click', function () {
        if (!navigator.geolocation) return;
        geo.setAttribute('aria-busy', 'true');
        navigator.geolocation.getCurrentPosition(function (p) {
          geo.removeAttribute('aria-busy');
          self.origin = { lat: p.coords.latitude, lng: p.coords.longitude };
          if (self.map) self.map.flyTo([self.origin.lat, self.origin.lng], 11, { duration: 0.6 });
          self.renderList();
        }, function () { geo.removeAttribute('aria-busy'); });
      });
      var filters = this.$('[data-filters]');
      if (filters) filters.addEventListener('click', function (e) {
        var b = e.target.closest('.hgloc-chip'); if (!b) return;
        self.activeFilter = b.getAttribute('data-f');
        self.querySelectorAll('.hgloc-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
        self.renderList(); self.buildMarkers();
      });
      if (this.listEl) this.listEl.addEventListener('click', function (e) {
        var v = e.target.closest('[data-map]');
        if (v) { e.preventDefault(); self.classList.add('map-open'); if (self.map) self.map.invalidateSize(); self.setActive(v.getAttribute('data-map'), true); return; }
        var card = e.target.closest('.hgloc-card');
        if (card && !e.target.closest('a[target="_blank"]')) { e.preventDefault(); self.setActive(card.getAttribute('data-id'), true); }
      });
      var mt = this.$('[data-mtoggle]'), mc = this.$('[data-mclose]');
      if (mt) mt.addEventListener('click', function () { self.classList.add('map-open'); setTimeout(function () { if (self.map) self.map.invalidateSize(); }, 350); });
      if (mc) mc.addEventListener('click', function () { self.classList.remove('map-open'); });
    }

    matches(s) { return this.activeFilter === 'all' || (s.ranges && s.ranges.indexOf(this.activeFilter) > -1); }

    sorted() {
      var self = this, arr = this.stores.filter(function (s) { return self.matches(s); });
      if (this.origin) { arr.forEach(function (s) { s._d = haversine(self.origin.lat, self.origin.lng, s.lat, s.lng); }); arr.sort(function (a, b) { return a._d - b._d; }); }
      else arr.sort(function (a, b) { return (a.country === 'IT' ? 0 : 1) - (b.country === 'IT' ? 0 : 1) || a.country.localeCompare(b.country) || a.city.localeCompare(b.city); });
      return arr;
    }

    badges(r) {
      if (!this.showRanges || !r || !r.length) return '';
      var food = FOOD.filter(function (k) { return r.indexOf(k) > -1; });
      var html = food.length === 3
        ? '<span class="hgloc-badge hgloc-badge--full">' + FULL_ICON + 'Gamma completa</span>'
        : food.map(function (k) { return '<span class="hgloc-badge hgloc-badge--' + RANGE[k].cls + '">' + RANGE[k].icon + RANGE[k].label + '</span>'; }).join('');
      if (r.indexOf('gatto') > -1) html += '<span class="hgloc-badge hgloc-badge--gatto">' + RANGE.gatto.icon + 'Gatto</span>';
      return '<div class="hgloc-badges">' + html + '</div>';
    }

    renderList() {
      if (!this.listEl) return;
      var self = this, arr = this.sorted();
      this.listEl.innerHTML = '';
      if (this.countEl) {
        var LBL = { secco: 'cibo secco', umido: 'cibo umido', snack: 'snack & biscotti', gatto: 'linea gatto' };
        var fl = this.activeFilter !== 'all' ? ' · ' + (LBL[this.activeFilter] || '') : '';
        this.countEl.innerHTML = '<b>' + arr.length + '</b> ' + (arr.length === 1 ? 'rivenditore' : 'rivenditori') + (this.showRanges ? fl : '');
      }
      if (this.emptyEl) this.emptyEl.classList.toggle('show', arr.length === 0);
      var lastGroup = null;
      arr.forEach(function (s) {
        if (!self.origin) {
          var g = s.country === 'IT' ? 'Italia' : 'Resto d\'Europa';
          if (g !== lastGroup) { lastGroup = g; var gl = document.createElement('div'); gl.className = 'hgloc-group'; gl.textContent = g; self.listEl.appendChild(gl); }
        }
        var el = document.createElement('article'); el.className = 'hgloc-card'; el.setAttribute('data-id', s.id);
        el.innerHTML =
          '<div class="hgloc-ctop">' +
            '<div class="hgloc-cpin"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 10c0 5.5-8 12-8 12s-8-6.5-8-12a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.6"/></svg></div>' +
            '<div class="hgloc-cbody">' +
              '<div class="hgloc-cname">' + (s.country !== 'IT' ? '<span class="hgloc-flag">' + (s.flag || '') + '</span>' : '') + esc(s.name) + '</div>' +
              '<div class="hgloc-caddr">' + esc(s.address) + '</div>' +
              '<div class="hgloc-ccity">' + esc(s.city) + (s.prov ? ' (' + esc(s.prov) + ')' : '') + ' · ' + esc(s.zip) + (s.country !== 'IT' ? ' · ' + esc(s.country_name || '') : '') + '</div>' +
            '</div>' +
            (self.origin ? '<span class="hgloc-cdist"><svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2 4 5v6c0 5 3.4 8.6 8 11 4.6-2.4 8-6 8-11V5l-8-3Z"/></svg>' + fmtDist(s._d) + '</span>' : '') +
          '</div>' +
          self.badges(s.ranges) +
          '<div class="hgloc-cact">' +
            '<a class="hgloc-clink" href="' + dirURL(s) + '" target="_blank" rel="noopener"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l19-9-9 19-2-8-8-2Z"/></svg>Indicazioni</a>' +
            '<a class="hgloc-clink" href="#" data-map="' + s.id + '" style="margin-left:auto;color:var(--ink-soft)">Vedi sulla mappa <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg></a>' +
          '</div>';
        self.listEl.appendChild(el);
      });
    }

    /* ---------- MAP (Leaflet) ---------- */
    initMap() {
      var el = this.$('.hgloc-map'); if (!el) return;
      this.map = L.map(el, { zoomControl: true, attributionControl: true, scrollWheelZoom: false }).setView(this.center, this.zoom);
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(this.map);
      this.map.on('click', function () {}, this);
      this.cluster = L.markerClusterGroup ? L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 46, spiderfyOnMaxZoom: true }) : null;
      if (this.cluster) this.map.addLayer(this.cluster);
      this.buildMarkers();
      this.ipLocate();
    }

    /* Auto-centra sulla zona del visitatore via IP (no permesso richiesto) */
    ipLocate() {
      var self = this;
      function apply(lat, lng) {
        if (self.origin) return; // l'utente ha già cercato/geolocalizzato: non sovrascrivere
        lat = parseFloat(lat); lng = parseFloat(lng);
        if (!isNaN(lat) && !isNaN(lng)) self.setOrigin(lat, lng, 10);
      }
      fetch('https://ipwho.is/?fields=success,latitude,longitude')
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.success) apply(j.latitude, j.longitude); else throw 0; })
        .catch(function () {
          fetch('https://get.geojs.io/v1/ip/geo.json')
            .then(function (r) { return r.json(); })
            .then(function (j) { apply(j.latitude, j.longitude); })
            .catch(function () {});
        });
    }

    pinIcon(active) {
      var s = active ? [40, 52] : [32, 42];
      return L.divIcon({ className: 'hgloc-pin' + (active ? ' is-active' : ''), html: pinSVG(active ? TEAL_DEEP : TEAL), iconSize: s, iconAnchor: [s[0] / 2, s[1]], popupAnchor: [0, -s[1] + 6] });
    }

    buildMarkers() {
      if (!this.map) return;
      var self = this;
      if (this.cluster) this.cluster.clearLayers();
      else if (this._mlist) this._mlist.forEach(function (m) { self.map.removeLayer(m); });
      this.markers = {}; this._mlist = [];
      this.stores.forEach(function (s) {
        if (!self.matches(s)) return;
        var m = L.marker([s.lat, s.lng], { icon: self.pinIcon(s.id === self.activeId) });
        m.bindPopup('<div class="hgloc-pop__name">' + (s.country !== 'IT' ? (s.flag || '') + ' ' : '') + esc(s.name) + '</div><div class="hgloc-pop__addr">' + esc(s.address) + '<br>' + esc(s.city) + ' ' + (s.prov ? '(' + esc(s.prov) + ')' : '') + ' ' + esc(s.zip) + '</div><a class="hgloc-pop__link" target="_blank" rel="noopener" href="' + dirURL(s) + '">Indicazioni →</a>');
        m.on('click', function () { self.highlightCard(s.id); });
        self.markers[s.id] = m; self._mlist.push(m);
        if (self.cluster) self.cluster.addLayer(m); else m.addTo(self.map);
      });
    }

    highlightCard(id) {
      this.activeId = id;
      this.querySelectorAll('.hgloc-card').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-id') === id); });
      var card = this.querySelector('.hgloc-card[data-id="' + id + '"]');
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    setActive(id, fromList) {
      var prev = this.activeId;
      if (prev && this.markers[prev]) this.markers[prev].setIcon(this.pinIcon(false));
      this.activeId = id;
      var s = this.stores.find(function (x) { return x.id === id; }); if (!s) return;
      var m = this.markers[id];
      if (m) m.setIcon(this.pinIcon(true));
      this.querySelectorAll('.hgloc-card').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-id') === id); });
      if (fromList && this.map) {
        this.map.flyTo([s.lat, s.lng], Math.max(this.map.getZoom(), 13), { duration: 0.6 });
        if (m && this.cluster) this.cluster.zoomToShowLayer(m, function () { m.openPopup(); });
        else if (m) m.openPopup();
        var card = this.querySelector('.hgloc-card[data-id="' + id + '"]');
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    /* ---------- SEARCH (free: local match -> Nominatim fallback) ---------- */
    setOrigin(lat, lng, zoom) {
      this.origin = { lat: lat, lng: lng };
      if (this.map) this.map.flyTo([lat, lng], zoom || 11, { duration: 0.6 });
      this.renderList();
    }
    search() {
      var self = this, qel = this.$('[data-q]'); if (!qel) return;
      var q = qel.value.trim(); if (!q) return;
      var cap = q.replace(/\D/g, '');
      var hits = [];
      if (/^\d{5}$/.test(cap)) hits = this.stores.filter(function (s) { return String(s.zip).replace(/\D/g, '') === cap; });
      if (!hits.length) {
        var ql = q.toLowerCase();
        hits = this.stores.filter(function (s) { return (s.city || '').toLowerCase().indexOf(ql) > -1 || (s.prov || '').toLowerCase() === ql; });
      }
      if (hits.length) {
        var la = hits.reduce(function (a, s) { return a + s.lat; }, 0) / hits.length;
        var ln = hits.reduce(function (a, s) { return a + s.lng; }, 0) / hits.length;
        this.setOrigin(la, ln, hits.length === 1 ? 13 : 11);
        return;
      }
      // fallback geocoder (free, low volume)
      var go = this.$('[data-go]'); var lab = go ? go.textContent : '';
      if (go) go.textContent = '…';
      fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=it,nl,be,de,fr,hu,at&accept-language=it&q=' + encodeURIComponent(q))
        .then(function (r) { return r.json(); })
        .then(function (j) { if (go) go.textContent = lab; if (j && j[0]) self.setOrigin(parseFloat(j[0].lat), parseFloat(j[0].lon), 11); })
        .catch(function () { if (go) go.textContent = lab; });
    }
  }
  if (!customElements.get('hg-store-locator')) customElements.define('hg-store-locator', HgStoreLocator);
})();
